import axios from 'axios';
import { handleResponse } from './HelperService';

const getLegalInfo = (params, onSuccess, onError) => {
    const response = axios.get('v1/legal', { params });
    return handleResponse(response, onSuccess, onError);
};

export {
    getLegalInfo,
};
